/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { PostApiBookingIdCancel200, PostApiBookingIdCancelMutationResponse, PostApiBookingIdCancelPathParams, PostApiBookingIdCancelQueryParams } from "../entities/PostApiBookingIdCancel";
import { modelsMessageResponseSchema } from "./models/messageResponseSchema";
import { z } from "zod/v4";

export const postApiBookingIdCancelPathParamsSchema = z.object({
    "id": z.coerce.number().int().describe("ID записи")
    }) as unknown as z.ZodType<PostApiBookingIdCancelPathParams>

export const postApiBookingIdCancelQueryParamsSchema = z.object({
    "branch_id": z.coerce.number().int().min(1).describe("ID филиала")
    }) as unknown as z.ZodType<PostApiBookingIdCancelQueryParams>

/**
 * @description OK
 */
export const postApiBookingIdCancel200Schema = z.lazy(() => modelsMessageResponseSchema) as unknown as z.ZodType<PostApiBookingIdCancel200>

export const postApiBookingIdCancelMutationResponseSchema = z.lazy(() => postApiBookingIdCancel200Schema) as unknown as z.ZodType<PostApiBookingIdCancelMutationResponse>